import { Outlet } from "react-router-dom";
import SideMenu from "./SideMenu";
import styled from "styled-components";

export default function AdminLayout() {
  return (
    <Page>
      <FullWidth>
        {/* SIDE MENU */}
        <div>
          <SideMenu />
        </div>

        {/* CENTRAL CONTENT */}
        <div style={{ marginLeft: "15%", marginTop: "-12%" }}>
          <Outlet />
        </div>
      </FullWidth>
    </Page>
  );
}

const Page = styled.div`
  min-height: 100vh;
  width: 100%;
  background-color: #ffffff;
`;

const FullWidth = styled.div`
  width: 100%;
`;
